"use strict";

exports.__esModule = true;
exports.default = void 0;
var options = {
  plugins: {
    legend: {
      display: false
    },
    tooltip: {
      callbacks: {
        label: function label(context) {
          return context.formattedValue + "%";
        }
      },
      displayColors: false
    }
  },
  scales: {
    xAxis: {
      ticks: {
        minRotation: 0,
        maxRotation: 0
      }
    },
    yAxis: {
      min: 0,
      max: 100,
      position: 'right',
      ticks: {
        callback: function callback(value) {
          return value + "%";
        }
      }
    }
  }
};
var _default = options;
exports.default = _default;